import {Injectable} from '@angular/core';

import {HttpInterceptor, HttpRequest, HttpHandler} from '@angular/common/http';

import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<never>, next: HttpHandler) {
    if (request.url.indexOf(environment.host) === 0) {
      const csrftoken = this.getCookie('portal_csrf_token');
      request = request.clone({
        withCredentials: true,
        headers: csrftoken ? request.headers.set('X-CSRFToken', csrftoken) : request.headers,
      });

      return next.handle(request).pipe(
        catchError((error: {status: number}, caught) => {
          if (error.status === 401) {
            this.redirectToLogin();
            return of([]);
          }

          throw error;
        }),
      ) as Observable<never>;
    }

    return next.handle(request);
  }

  redirectToLogin() {
    window.location.href = environment.host + '?next=' + encodeURI(location.href);
  }

  private getCookie(name: string) {
    let cookieValue: string | null = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === name + '=') {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
}
